// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import { useIncomingPayment, getCustomerEmail, getCountry } from '@tectonics/prs/incoming-payment';
import { type Country } from '@tectonics/prs/country';

export function EmailInfo(): Node {
  const incomingPayment = useIncomingPayment();
  const customerEmail = getCustomerEmail(incomingPayment);
  const country = getCountry(incomingPayment);

  return (
    <Root>
      <EmailInfoMessage country={country} />
      &nbsp;
      <strong>{customerEmail}</strong>.
    </Root>
  );
}

type EmailInfoMessageProps = {|
  country: Country,
|};

function EmailInfoMessage({ country }: EmailInfoMessageProps): Node {
  switch (country) {
    case 'br':
      return 'Você deve receber um e-mail de confirmação em breve e se tiver qualquer dúvida em relação ao pagamento, é só acessar a Conta EBANX com o e-mail';
    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'uy':
    case 'py':
    case 'pa':
    case 'cr':
    case 'sv':
    case 'gt':
    case 'do':
      return 'Pronto recibirás un correo electrónico de confirmación y si tiene alguna pregunta sobre el pago, simplemente acceda a la Cuenta EBANX con el correo electrónico.';
    case 'ke':
    case 'ng':
    case 'za':
    case 'eg':
    case 'in':
      return 'You should receive an confirmation e-mail soon and if you have any questions regarding the payment, you can access the EBANX account with the e-mail';
    default:
      throw new Error(`PE EmailInfo: country ${country} is not supported`);
  }
}

const Root = styled.p`
  padding: 0 2em;
`;
